import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";

export default async function ({ page }) {
  const data = page;
  await setDoc(doc(db, "pages", page.id), data);
}
